import { useEffect, useRef, useState } from 'react';
import Carousel from '../carousel/Carousel';
import './detailsImageDisplay.css';

function DetailsImageDisplay({ imageData, videoData }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const containerRef = useRef(null);
    const thumbnailRefs = useRef([]);

    const openModal = (index) => {
        setCurrentIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    const showPrev = () => setCurrentIndex((prevIndex) => (prevIndex - 1 + imageData.length) % imageData.length);
    const showNext = () => setCurrentIndex((prevIndex) => (prevIndex + 1) % imageData.length);

    const handleLoadMore = () => {
        setIsModalOpen(true);
    };

    useEffect(() => {
        if (!isModalOpen) return;
        if (isModalOpen && containerRef.current) {
            containerRef.current.focus();
        }
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') {
                showPrev();
            } else if (event.key === 'ArrowRight') {
                showNext();
            } else if (event.key === 'Escape') {
                closeModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
        //eslint-disable-next-line
    }, [isModalOpen]);

    useEffect(() => {
        if (thumbnailRefs.current[currentIndex]) {
            thumbnailRefs.current[currentIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }, [currentIndex]);

    return (
        <>
            <Carousel customClass='mobSlider' imageData={imageData} videoData={videoData} />
            <div className='tripDetailsDiv'>
                <div className='tripDetailsImages'>
                    <div className='tripDetailsMainImage'>
                        <img
                            alt='trvto_nature'
                            src={imageData[0]}
                            className='tripDetailsMainImg'
                            loading='lazy'
                            decoding='async'
                            onClick={() => openModal(0)}
                        />
                    </div>
                    {videoData?.length > 0 ? (
                        <div className='verticalVideoContainer'>
                            <video className='tripDetailsOtherImg2' src={videoData[0]} controls autoPlay={false} />
                        </div>
                    ) : (
                        <div className='tripDetailsOtherImages'>
                            <img
                                alt='trvto_nature'
                                src={imageData[1]}
                                className='tripDetailsOtherImg3'
                                loading='lazy'
                                decoding='async'
                                onClick={() => openModal(3)}
                            />
                            <img
                                alt='trvto_nature'
                                src={imageData[2]}
                                className='tripDetailsOtherImg4'
                                loading='lazy'
                                decoding='async'
                                onClick={() => openModal(4)}
                            />
                        </div>
                    )}
                    <div className='tripDetailsOtherImages'>
                        <img
                            alt='trvto_nature'
                            src={imageData[3]}
                            className='tripDetailsOtherImg3'
                            loading='lazy'
                            decoding='async'
                            onClick={() => openModal(3)}
                        />
                        <img
                            alt='trvto_nature'
                            src={imageData[4]}
                            className='tripDetailsOtherImg4'
                            loading='lazy'
                            decoding='async'
                            onClick={() => openModal(4)}
                        />
                        <button className='load-more-btn' onClick={handleLoadMore}>
                            Load More
                        </button>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <div className='imageModalOverlay' onClick={closeModal}>
                    <div className='imageModalContent' onClick={(e) => e.stopPropagation()}>
                        <button className='modalNavButton left' onClick={showPrev}>
                            ‹
                        </button>
                        <img src={imageData[currentIndex]} alt='trvto_nature_fullview' className='modalImage' />
                        <button className='modalNavButton right' onClick={showNext}>
                            ›
                        </button>
                        <div ref={containerRef} className='thumbnail-container'>
                            {imageData.map((image, index) => (
                                <img
                                    ref={(el) => (thumbnailRefs.current[index] = el)}
                                    key={index}
                                    src={image}
                                    alt={`thumb-${index}`}
                                    onClick={() => setCurrentIndex(index)}
                                    className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default DetailsImageDisplay;
